var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaxTotalsBase',{attrs:{"route-key":_vm.routeKey,"key1":_vm.key1,"key2":_vm.key2,"key2plural":_vm.key2Plural,"sort-key":_vm.sortKey}})}
var staticRenderFns = []

export { render, staticRenderFns }